import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const StackedBarChart = ({
  data,
  xAxisKey,
  barKeys,
  height = 300,
}) => {
  return (
    <div className="w-full">
      <ResponsiveContainer width="100%" height={height}>
        <BarChart
          data={data}
          margin={{
            top: 10,
            right: 20,
            left: 0,
            bottom: 10,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          {xAxisKey && (
            <XAxis 
              dataKey={xAxisKey} 
              tick={{ fontSize: 12 }} 
              tickFormatter={(tick) => tick.length > 10 ? `${tick.substring(0, 8)}...` : tick} 
            />
          )}
          <YAxis tick={{ fontSize: 12 }} />
          <Tooltip wrapperStyle={{ fontSize: "12px" }} />
          
          {/* Hide Legend on small screens */}
          <Legend wrapperStyle={{ fontSize: "12px" }} height={window.innerWidth < 500 ? 20 : 40} />

          {barKeys.map((bar, index) => (
            <Bar
              key={bar.key}
              dataKey={bar.key}
              stackId="a"
              fill={bar.color}
              barSize={window.innerWidth < 500 ? 10 : 20} // Smaller bars on small screens
            />
          ))}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default StackedBarChart;
